import claim1 from "@/assets/claim/claim-1.webp.asset.json";
import claim2 from "@/assets/claim/claim-2.webp.asset.json";
import claim3 from "@/assets/claim/claim-3.webp.asset.json";
import claim4 from "@/assets/claim/claim-4.webp.asset.json";
import claim5 from "@/assets/claim/claim-5.webp.asset.json";
import claim6 from "@/assets/claim/claim-6.webp.asset.json";
import claim7 from "@/assets/claim/claim-7.webp.asset.json";
import claim8 from "@/assets/claim/claim-8.webp.asset.json";
import claim9 from "@/assets/claim/claim-9.webp.asset.json";
import claim10 from "@/assets/claim/claim-10.webp.asset.json";
import claim11 from "@/assets/claim/claim-11.webp.asset.json";
import claim12 from "@/assets/claim/claim-12.webp.asset.json";
import claim13 from "@/assets/claim/claim-13.webp.asset.json";
import claim14 from "@/assets/claim/claim-14.webp.asset.json";
import claim15 from "@/assets/claim/claim-15.webp.asset.json";
import claim16 from "@/assets/claim/claim-16.webp.asset.json";
import claim17 from "@/assets/claim/claim-17.webp.asset.json";
import claim18 from "@/assets/claim/claim-18.webp.asset.json";
import claim19 from "@/assets/claim/claim-19.webp.asset.json";
import claim20 from "@/assets/claim/claim-20.webp.asset.json";
import claim21 from "@/assets/claim/claim-21.webp.asset.json";
import claim22 from "@/assets/claim/claim-22.webp.asset.json";
import claim23 from "@/assets/claim/claim-23.webp.asset.json";
import claim24 from "@/assets/claim/claim-24.webp.asset.json";
import claim25 from "@/assets/claim/claim-25.webp.asset.json";

export const claimMarqueeImages: { src: string; alt: string }[] = [
  { src: claim1.url, alt: "" },
  { src: claim15.url, alt: "" },
  { src: claim2.url, alt: "" },
  { src: claim18.url, alt: "" },
  { src: claim3.url, alt: "" },
  { src: claim14.url, alt: "" },
  { src: claim4.url, alt: "" },
  { src: claim17.url, alt: "" },
  { src: claim5.url, alt: "" },
  { src: claim23.url, alt: "" },
  { src: claim6.url, alt: "" },
  { src: claim20.url, alt: "" },
  { src: claim7.url, alt: "" },
  { src: claim19.url, alt: "" },
  { src: claim8.url, alt: "" },
  { src: claim24.url, alt: "" },
  { src: claim9.url, alt: "" },
  { src: claim16.url, alt: "" },
  { src: claim10.url, alt: "" },
  { src: claim22.url, alt: "" },
  { src: claim11.url, alt: "" },
  { src: claim21.url, alt: "" },
  { src: claim12.url, alt: "" },
  { src: claim25.url, alt: "" },
  { src: claim13.url, alt: "" },
];
